<template>
  <div class="dropdown" v-click-outside="close">
    <button
        class="btn btn-text-secondary rounded-pill text-muted border-0 p-2 me-n1 waves-effect waves-light"
        :class="opened ? 'show' : ''"
        type="button" id="earningReportsId" data-bs-toggle="dropdown" aria-haspopup="true"
        @click="toggleOpen()"
        aria-expanded="false">
      <i class="ti ti-dots-vertical ti-md text-muted"></i>
    </button>
    <div
        @click="close"
        class="dropdown-menu dropdown-menu-end" aria-labelledby="earningReportsId" :class="opened ? 'show' : ''">
      <slot/>
    </div>
  </div>
</template>
<script>
import {VOnClickOutside as ClickOutside} from "@/helpers/directives/clickOutside"

export default {
  name: 'DropdownComponent',
  data() {
    return {
      opened: false
    }
  },
  directives: {
    ClickOutside
  },
  methods: {
    toggleOpen() {
      this.opened = !this.opened
    },
    close() {
      this.opened = false
    }
  },
}
</script>

<style>
.loading-button {
  position: relative;
}

.loading-button .spinner-border, .loading-button .spinner-grow {
  position: absolute;
  top: auto;
  left: auto;
  bottom: auto;
  right: auto;
}
</style>